import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = { class: "mt-10 mb-10" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("下载凭证")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("金蝶模板导出")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("上传模板导出")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("贷方")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("借方")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("确定")

import { ref, reactive, onBeforeMount, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatTime, exportHandle } from '@/utils/index'
import FinancialAssistant from './ViewsComponents/financial/FinancialAssistant.vue'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/voucher_subject/query': fetchList,
  // 凭证科目_添加
  'POST/voucher_subject': subjectAddApi,
  // 凭证科目_修改
  'PATCH/voucher_subject': subjectEditApi,
  // 凭证科目_删除
  'DELETE/voucher_subject/{id}': voucherDelApi,
  // 凭证科目_上传
  'POST/voucher_subject/upload': uploadApi,
  // 下载科目凭证
  'POST/voucher_subject/download': downloadApi,
  // 辅助合算下拉
  // 'GET/voucher_assists': voucher_assistsApi,
  // 辅助核算类别
  'POST/voucher_assist_categorys/list':vocherAssistCategorysListApi,
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)
const queryInfo=ref<any>({
  open:true
})
const subjectInfo=ref<any>({
  balanceDirection:'Credit',
  cashFlow:false
})
const pageInfo=reactive({
  page:1,
  size:100,
  total:0
})

const voucherList: any = ref([])
onBeforeMount(() => {
  vocherAssistCategorysListApi({name:''}).then((rep: any) => {
    voucherList.value = rep
  })
})
// 添加
const isShowAdd = ref<boolean>(false)
const parentSubject=ref<any>({})
const showParentSubject=ref(false)
const addHandle = (data:any={},showParent:boolean=false) => {
  parentSubject.value=data
  showParentSubject.value=showParent
  isShowAdd.value=true
  subjectInfo.value.parentName=data.subjectFullName||''
  subjectInfo.value.subjectType=data.subjectType||''
}
const subjectFormRef=ref()
const addLoading=ref(false)
const addSubject = (formEl:any)=>{
  if (!formEl) return;
  formEl.validate((valid:any, fields:any) => {
    if (!valid) return;
    
    let {subjectCode,subjectName,subjectType,balanceDirection,
      cashFlow,forexCurrency,summary,id,pid,assistCategoryId}=subjectInfo.value 
    let params:any={
      subjectCode,subjectName,
      subjectType: subjectType||null,
      balanceDirection,
      cashFlow,
      forexCurrency: forexCurrency||null,
      summary: summary||null,
      assistCategoryId: assistCategoryId||null
    }
    addLoading.value=true
    if(id){ //修改
      params.id=id
      params.pid=pid
      subjectEditApi(params).then(()=>{
        ElMessage.success('修改成功')
        isShowAdd.value=false
        getSubjects()
      }).finally(()=>{
        addLoading.value=false
      })
    }else{ //新增          
        params.pid=parentSubject.value.id||0
        subjectAddApi(params).then(()=>{
        ElMessage.success('添加成功')
        isShowAdd.value=false
        getSubjects()
      }).finally(()=>{
        addLoading.value=false
      })
    }
  })
}
const resetForm=(formEl:any)=>{
  if (!formEl) return
  formEl.resetFields()
  subjectInfo.value={
    balanceDirection:'Credit',
    cashFlow:false
  }
  parentSubject.value={}
  showParentSubject.value=false
}

// 修改
const modifyHandle = (row: any) => {
  subjectInfo.value=JSON.parse(JSON.stringify(row))
  parentSubject.value=JSON.parse(JSON.stringify(row))
  isShowAdd.value=true
  subjectInfo.value.subjectCode=row.pid==0?row.subjectCode:(row.subjectCode as string).split(row.parentSubjectCode)[1]
  subjectInfo.value.parentName=row.pid==0?'':row.parentName||row.pid
}

// 删除
const delHandle = (row: any) => {
  ElMessageBox.confirm(
    `是否确认删除:${row.subjectCode}?`,
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
      MI_identify.value = true
      return voucherDelApi({id: row.id})
    })
    .then(() => {
      MI_identify.value = false
      ElMessage.success('删除成功')
      // fetchData(MI_params)
      getSubjects()
    })
    .catch(() => {
      MI_identify.value = false
    })
}

const getSubjects=(isreset:boolean=false)=>{
  if(isreset){
    queryInfo.value={
      open:true
    }
    pageInfo.size=100,
    pageInfo.page=1
  }
  MI_identify.value=true
  let {page,size}=pageInfo
  let params={
    open:queryInfo.value.open,
    subjectType:queryInfo.value.subjectType||'',
    codeAndNameKey:queryInfo.value.codeAndNameKey||'',page,size
  }
  fetchList(params).then((res:any)=>{
    MI_tableData.value=res.data
    pageInfo.total=res.rowCount
  }).finally(()=>{
    MI_identify.value=false
  })
}

// 下载凭证
const downloadVoucher = (subjectTemplate:string) => {
  ElMessageBox.confirm('请确认是否下载凭证', '提示').then(() => {
    MI_identify.value = true
    return exportHandle(downloadApi, {...queryInfo.value,subjectTemplate})
  }).finally(() => {
    MI_identify.value = false
  })
}

onMounted(()=>{
  getSubjects()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tabs, { type: "border-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { label: "凭证科目" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_collapse_item, { title: "凭证科目-查询" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form, {
                      inline: "",
                      model: queryInfo.value,
                      class: "searchBg"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "科目名称/科目代码:" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: queryInfo.value.codeAndNameKey,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryInfo.value.codeAndNameKey) = $event)),
                              clearable: "",
                              class: "form-input",
                              maxlength: "200",
                              placeholder: "请输入科目名称(代码)"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "科目类别:" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: queryInfo.value.subjectType,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryInfo.value.subjectType) = $event)),
                              clearable: "",
                              class: "form-input",
                              maxlength: "200",
                              placeholder: "请输入科目类别"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: " " }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_checkbox, {
                              label: "展开所有次级",
                              modelValue: queryInfo.value.open,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryInfo.value.open) = $event)),
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (getSubjects()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_1
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (getSubjects(true)))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_2
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (addHandle()))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_TheUpBtn, {
                class: "ml-10",
                upText: '上传凭证',
                upFetch: _unref(uploadApi),
                upParams: {},
                showBtn: true
              }, null, 8, ["upFetch"]),
              _createVNode(_component_el_dropdown, {
                style: {"outline":"none"},
                onCommand: downloadVoucher
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, { command: "Kingdee" }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_dropdown_item, { command: "Upload" }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, { class: "ml-10" }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              ref: "tb",
              border: "",
              data: _unref(MI_tableData),
              "max-height": _unref(MI_height) - 70 + 'px'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "科目代码",
                  prop: "subjectCode",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "科目名",
                  prop: "subjectName",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "科目全名",
                  prop: "subjectFullName",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "余额方向",
                  prop: "balanceDirection",
                  "show-overflow-tooltip": "",
                  formatter: (row) => row.balanceDirection === 'Credit' ? '贷方' : '借方'
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "科目类别",
                  prop: "subjectType",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "外币核算",
                  prop: "forexCurrency",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "核算维护",
                  prop: "assistCategoryName",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "摘要",
                  prop: "summary",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "创建时间",
                  prop: "createAt",
                  "show-overflow-tooltip": "",
                  formatter: _unref(formatTime)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "创建人",
                  prop: "createName",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "更新时间",
                  prop: "updateAt",
                  "show-overflow-tooltip": "",
                  formatter: _unref(formatTime)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "更新人",
                  prop: "updateBy",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  width: "150"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_link, {
                          type: "primary",
                          onClick: ($event: any) => (addHandle(row,true))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_link, {
                          type: "primary",
                          onClick: ($event: any) => (modifyHandle(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_link, {
                          type: "danger",
                          onClick: ($event: any) => (delHandle(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "max-height"])), [
              [_directive_loading, _unref(MI_identify)]
            ]),
            _createVNode(_component_el_pagination, {
              background: "",
              small: "",
              total: _unref(pageInfo).total,
              "page-size": _unref(pageInfo).size,
              currentPage: _unref(pageInfo).page,
              "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((_unref(pageInfo).page) = $event)),
              class: "mb-5 mt-5",
              "page-sizes": [100, 150, 200, 300],
              layout: "sizes, prev, pager, next, total, jumper",
              onCurrentChange: _cache[7] || (_cache[7] = ()=>getSubjects()),
              onSizeChange: _cache[8] || (_cache[8] = ()=>getSubjects())
            }, null, 8, ["total", "page-size", "currentPage"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "辅助核算",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(FinancialAssistant)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      onClose: _cache[20] || (_cache[20] = ($event: any) => (resetForm(subjectFormRef.value))),
      modelValue: isShowAdd.value,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((isShowAdd).value = $event)),
      title: subjectInfo.value.id?'修改凭证':'新增凭证',
      width: "550"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          disabled: addLoading.value,
          onClick: _cache[18] || (_cache[18] = ($event: any) => (isShowAdd.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          loading: addLoading.value,
          type: "primary",
          onClick: _cache[19] || (_cache[19] = ($event: any) => (addSubject(subjectFormRef.value)))
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "subjectFormRef",
          ref: subjectFormRef,
          "label-width": "auto",
          model: subjectInfo.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "科目编码",
              prop: "subjectCode",
              rules: [{required:true, message:'请输入科目编码'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: subjectInfo.value.subjectCode,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((subjectInfo.value.subjectCode) = $event)),
                  maxlength: "200",
                  clearable: "",
                  placeholder: "请输入科目编码"
                }, _createSlots({ _: 2 }, [
                  (showParentSubject.value||parentSubject.value.pid&&parentSubject.value.pid!=0)
                    ? {
                        name: "prepend",
                        fn: _withCtx(() => [
                          _createTextVNode(_toDisplayString(showParentSubject.value||parentSubject.value.pid==0?parentSubject.value.subjectCode:parentSubject.value.parentSubjectCode), 1)
                        ])
                      }
                    : undefined
                ]), 1032, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "科目名称:",
              prop: "subjectName",
              rules: [{required:true, message:'请输入科目名称'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: subjectInfo.value.subjectName,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((subjectInfo.value.subjectName) = $event)),
                  placeholder: "请输入科目名称",
                  clearable: "",
                  maxlength: "200"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "上级科目:",
              prop: "parentName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: subjectInfo.value.parentName,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((subjectInfo.value.parentName) = $event)),
                  disabled: "",
                  placeholder: "无上级科目",
                  maxlength: "200"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "科目类别:",
              prop: "subjectType",
              rules: [{required:true,message:'请输入科目类别'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: subjectInfo.value.subjectType,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((subjectInfo.value.subjectType) = $event)),
                  placeholder: "请输入科目类别",
                  clearable: "",
                  maxlength: "200"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "外币核算:",
              prop: "forexCurrency"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: subjectInfo.value.forexCurrency,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((subjectInfo.value.forexCurrency) = $event)),
                  placeholder: "请输入外币核算",
                  clearable: "",
                  maxlength: "200"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "辅助核算:",
              prop: "assistCategoryId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: subjectInfo.value.assistCategoryId,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((subjectInfo.value.assistCategoryId) = $event)),
                  placeholder: "请选择辅助核算",
                  clearable: "",
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(voucherList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "余额方向:",
              style: {"align-items":"center"},
              prop: "balanceDirection",
              rules: [{required:true,message:'选择余额方向'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: subjectInfo.value.balanceDirection,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((subjectInfo.value.balanceDirection) = $event)),
                  class: "ml-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      label: "Credit",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      label: "Debit",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "是否为现金科目:",
              prop: "cashFlow"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: subjectInfo.value.cashFlow,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((subjectInfo.value.cashFlow) = $event)),
                  label: "",
                  size: "large"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "摘要:",
              prop: "summary"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: subjectInfo.value.summary,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((subjectInfo.value.summary) = $event)),
                  placeholder: "请输入摘要",
                  maxlength: "500"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})